import React, { useEffect, useRef, useState } from "react";
import { Spinner, Button } from "react-bootstrap";
import { COLOR_APP, COLOR_TEXT, FACEBOOK_API_VERSION } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { IoMdAddCircle } from "react-icons/io";
import { IoSend } from "react-icons/io5";
import { AiTwotoneLike } from "react-icons/ai";
import axios from "axios";
import _ from "lodash";

const MessageList = ({
  fbUserMessages,
  setFbUserMessages, // Add this prop to allow updating messages from parent
  selectedFbUser,
  isLoadingMessages,
  setIsCreatedOrder,
  isCreatedOrder,
  fetchFbUserMessages, 
  pageAccessToken
}) => {
  const messagesEndRef = useRef(null);
  const [newMessage, setNewMessage] = useState("");

  // console.log("pageAccessToken:::", pageAccessToken)
  console.log("user ID:::", selectedFbUser?.senders?.data)

  // Scroll to the bottom of the messages
  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [fbUserMessages]);

  // Check if the message sender is the owner
  const isOwner = (message) => {
    return selectedFbUser?.senders?.data[0]?.id !== message?.from?.id;
  };

  // Reload messages
  const handleClickReload = () => {
    fetchFbUserMessages(selectedFbUser);
  };

  // Handle message input change
  const handleChangeMsg = (e) => {
    setNewMessage(e.target.value);
  };

  // Handle message sending on Enter key press
  const handleSendMessage = (e) => {
    if (e.key === "Enter") {
      console.log("newMessage:::", newMessage, pageAccessToken, selectedFbUser?.senders?.data)
      sendMessage();
    }
  };

  // Send a new message
  const sendMessage = async () => {
    if (newMessage.trim() === "") return;

// let pageAccessToken = "EAAJ4D9SoBDsBO3WgS07jyZBfXYdVDCbjGAVfasv9zpw6XZAsCHRb8yHL2FPjvXM3Rhlhf7o6veN1OUv27wZCFhlJvXChp8KMKAHL7oo9ZAGZCxi2zPGTv9gTf0sE0rwOZAjtJ963jTEWD6gkuxhZBCMcav1YCApNeTFgOzME0HvAsGQfKZAsZBHqoQlToejqtORUKluM1Vxbbem2Dqs4ZD";


    try {
      await axios.post(
        `https://graph.facebook.com/${FACEBOOK_API_VERSION}/me/messages?access_token=${pageAccessToken}`,
        {
          recipient: { id: selectedFbUser?.senders?.data[0]?.id },
          message: { text: newMessage },
        }
      );

      fetchFbUserMessages(selectedFbUser);
      setNewMessage("");
      scrollToBottom();
    } catch (error) {
      console.error("Error sending message:", error);
      console.error("Error sending message:", error);
    
        // Add specific error handling here if needed
        if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
        } else if (error.request) {
        console.error("Request data:", error.request);
        } else {
        console.error("Error message:", error.message);
        }
    }
  };

  // Display loading spinner if no messages
  if (_.isEmpty(fbUserMessages)) {
    return (
      <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <img src="https://i.pinimg.com/originals/e3/1b/75/e31b752875679b64fce009922f9f0dda.gif" style={{ width: 300 }} />
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #EEE",
          paddingRight: 10
        }}
      >
        <div onClick={handleClickReload} style={{ cursor: "pointer" }}>
          <img
            style={{
              width: 40,
              height: 40,
              borderRadius: "100%",
              marginLeft: 10,
            }}
            alt=""
            src={selectedFbUser?.picture}
          />
          <span style={{ fontSize: 18, fontWeight: "bold", color: COLOR_APP }}>
            {selectedFbUser?.senders?.data[0]?.name}
          </span>
        </div>
        {selectedFbUser && !isCreatedOrder && (
          <Button
            variant="outline-secondary"
            onClick={() => setIsCreatedOrder(true)}
            style={{
              borderRadius: 5,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: 14
            }}
          >
            <FontAwesomeIcon icon={faPlus} className="mx-1" />
            ສ້າງອໍເດີ້
          </Button>
        )}
      </div>
      <div style={{ height: "85vh", overflow: "auto", padding: isCreatedOrder ? 10 : 24, paddingBottom: '5em' }}>
        {
          fbUserMessages?.map((message, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                padding: 10,
                marginBottom: 2,
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: isOwner(message) ? "end" : "start",
                }}
              >
                <span
                  style={{
                    maxWidth: isCreatedOrder ? "65%" : "50%",
                    background: isOwner(message) ? "rgba(26,102,190,1)" : "#EEE",
                    color: isOwner(message) && "white",
                    borderRadius: isOwner(message)
                      ? "10px 10px 0px 10px"
                      : "10px 10px 10px 0px",
                    padding: 5,
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {message?.message}
                </span>
              </div>
            </div>
          ))
        }
        <div ref={messagesEndRef} />
      </div>
      <div className="message-admin-chat">
        <div>
          <IoMdAddCircle style={{ fontSize: 22, color: COLOR_TEXT }} />
        </div>
        <div>
          <input
            value={newMessage}
            onChange={(e) => setNewMessage(e?.target?.value)}
            onKeyDown={handleSendMessage}
            placeholder="Type a message..."
            className="msg-control"
          />
        </div>
        <div className="message-linke">
          {newMessage ? (
            <IoSend style={{ fontSize: 22, color: COLOR_TEXT }} onClick={sendMessage} />
          ) : (
            <AiTwotoneLike style={{ fontSize: 22, color: COLOR_TEXT }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MessageList;
